export default __webpack_public_path__ + "static/media/back.96dff3fe.svg";